import styled from 'styled-components';

export const GridLayout = styled.div`
  display: grid;
  grid-template-areas:
    'overview overview'
    'configs methods'
    'configs reasons';
  grid-template-columns: 1fr 1fr;
  grid-template-rows: auto auto 1fr;
  grid-gap: 20px;
  align-items: start;
  margin-top: 20px;

  @media (max-width: 768px) {
    grid-template-areas:
      'overview'
      'configs'
      'methods'
      'reasons';
    grid-template-columns: auto;
    grid-template-rows: auto;
  }
`;

export const Overview = styled.div`
  grid-area: overview;
  align-self: start;
`;

export const Configs = styled.div`
  grid-area: configs;
  align-self: start;
`;

export const Methods = styled.div`
  grid-area: methods;
  align-self: start;
`;

export const Reasons = styled.div`
  grid-area: reasons;
  align-self: start;
`;
